import { render } from "./ChevronDown.vue?vue&type=template&id=c98ac654"
import script from "./ChevronDown.vue?vue&type=script&lang=js"
export * from "./ChevronDown.vue?vue&type=script&lang=js"
script.render = render

export default script